import type { Role } from '../role';
import { useRoleContext } from '../RoleContext';

const useRole = (): Role => {
  return useRoleContext();
};

export default useRole;
